import mutations from './mutations'
import state from './states'

export default {
  namespaced: true,
  state,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/shared/index.js